import React, { createContext, useContext, useState, useEffect } from "react";
import { FetchFromServer } from "../api/ServerApi";

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [userDetails, setUserDetails] = useState(null);
  const [candidateMappings, setCandidateMappings] = useState([]);
  const [loading, setLoading] = useState(true);

  // 🔹 Load from localStorage on app start
  useEffect(() => {
    const storedUser = localStorage.getItem("USER_DETAILS");
    const storedCandidates = localStorage.getItem("CANDIDATE_MAPPINGS");

    if (storedUser && storedCandidates) {
      setUserDetails(JSON.parse(storedUser));
      setCandidateMappings(JSON.parse(storedCandidates));
      setLoading(false);
    }
  }, []);

  // 🔹 Fetch from API (only if not present)
  const fetchUserAndPanels = async (mobileNumber) => {
    try {
      setLoading(true);

      const data = await FetchFromServer(
        "GetListOfCorpPanelsForUserbyMobileNumber",
        { MobileNumber: mobileNumber }
      );

      if (!Array.isArray(data) || !data[0]) return;

      const user = data[0];
      const mappings = user.CandidateMappings || [];

      // save to state
      setUserDetails(user);
      setCandidateMappings(mappings);

      // save to localStorage
      localStorage.setItem("USER_DETAILS", JSON.stringify(user));
      localStorage.setItem(
        "CANDIDATE_MAPPINGS",
        JSON.stringify(mappings)
      );
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Optional: clear on logout
  const clearUserData = () => {
    localStorage.removeItem("USER_DETAILS");
    localStorage.removeItem("CANDIDATE_MAPPINGS");
    setUserDetails(null);
    setCandidateMappings([]);
  };

  return (
    <UserContext.Provider
      value={{
        userDetails,
        candidateMappings,
        loading,
        fetchUserAndPanels,
        clearUserData,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

// custom hook
export const useUser = () => useContext(UserContext);
